import { createTheme } from "@mui/material/styles";

const baseTheme = createTheme({
  typography: {
    fontFamily: "Gotham, Arial, sans-serif",
  },
  components: {
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       textTransform: "none",
    //     },
    //   },
    // },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Gotham, Arial, sans-serif",
        },
      },
    },
  },
});

export default baseTheme;
